// extracted by mini-css-extract-plugin
module.exports = {"Header":"SortableHeader_Header__2ugcX"};